import React, { useEffect, useState } from 'react';
import PreloadWorkerComponent from './PreloadWorkerComponent';

function PreloadWrapper() {
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		const handleLoad = () => {
			setIsLoaded(true);
		};

		window.addEventListener('load', handleLoad);

		return () => {
			window.removeEventListener('load', handleLoad);
		};
	}, []);
	return (
		<>
			{ isLoaded && <PreloadWorkerComponent /> }
		</>
	);
}

export default PreloadWrapper;
